/* Preserve the visitor's chosen offer without altering existing cart lines. */
(() => {
  const config = window.mellowbyOfferIsolation;
  if (!config || window.mellowbyOfferIsolationReady) return;
  window.mellowbyOfferIsolationReady = true;
  const cardSelector = '.ms-card, .ml-card, .card-wrapper, .predictive-search__list-item, .cart-drawer__recommendation, .cart-drawer__rec-card, mel-cart-upsell, .jh-hero, .jh-birthstones, .jh-story, .jh-christmas__product';
  const cartLineSelector = '.cart-item, [data-cart-item], .cart-drawer__item';
  let observing = false;
  let observer;
  let suspended = false;
  let queued = false;
  let assignmentAttempted = false;

  function sameStore(url) {
    return url.hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, '');
  }

  function hide(element) {
    element.hidden = true;
    element.setAttribute('data-mellowby-offer-hidden', '');
    if (element.getAttribute('aria-selected') === 'true') {
      element.setAttribute('aria-selected', 'false');
      const search = element.closest('predictive-search');
      const input = search?.querySelector('input[aria-activedescendant]');
      if (input?.getAttribute('aria-activedescendant') === element.id) input.removeAttribute('aria-activedescendant');
    }
  }

  function apply() {
    queued = false;
    if (suspended) return;
    if (!config.restore()) return;
    for (const link of document.querySelectorAll('a[href]')) {
      if (link.closest(cartLineSelector)) continue;
      let url;
      try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { continue; }
      if (!sameStore(url)) continue;
      if (/\/pages\/witch-knot-november-sale\/?$/.test(url.pathname)) {
        hide(link);
        continue;
      }
      const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
      const replacement = match && config.replacements[match[1]];
      if (!replacement) continue;
      const card = link.closest(cardSelector);
      if (card) {
        hide(card.closest('.product-grid > .grid__item') || card);
        continue;
      }
      // Navigation and editorial links lead to the selected offer. Foreign
      // variant/selling-plan IDs cannot be carried to a duplicated product.
      url.pathname = url.pathname.replace('/products/' + match[1], '/products/' + replacement);
      url.searchParams.delete('variant');
      url.searchParams.delete('selling_plan');
      link.href = url.href;
    }
    if (!observing && document.body) {
      observing = true;
      observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(apply);
      });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    }
    if (!config.cartAssigned && !assignmentAttempted && window.fetch) {
      assignmentAttempted = true;
      // Only an attribute is updated: never send items, quantities, discounts,
      // or checkout instructions in this background request.
      const root = config.root.replace(/\/?$/, '/');
      fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [config.key]: config.id } }),
      }).then(response => {
        if (response.ok) config.cartAssigned = true;
      }).catch(() => {}); // Session/cookie filtering still works while offline.
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  window.addEventListener('pagehide', () => {
    suspended = true;
    observer?.disconnect();
    observing = false;
  });
  window.addEventListener('pageshow', () => { suspended = false; apply(); });
  window.addEventListener('storage', apply);
  window.addEventListener('focus', apply);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) apply(); });
  document.addEventListener('shopify:section:load', apply);
})();
